<div *ngIf="editMode; else staticTemplate" class="hours-and-minutes-selectors">
  <div class="time-selector">

      <input class="time"
        timeParse
        [(ngModel)]="value"
        (ngModelChange)="value=$event; propagateValue($event)"
        type="string"/>
        <div class="selector-buttons" *ngIf="valueIsValid()">
            <i class="fas fa-chevron-up selector-icon" (click)="add()"></i>
            <i class="fas fa-chevron-down selector-icon" (click)="reduce()"></i>
        </div>
  </div>
</div>

<ng-template #staticTemplate>
    <span class="static-time">{{value}}</span>
</ng-template>
